export default __webpack_public_path__ + "static/media/stephAndSimon.ed84ee4f.jpg";